// Helper method to safely convert date to ISO string regardless of whether it's Luxon DateTime or JS Date
export const convertDateToISOString = (date: any): string => {
  if (typeof date === 'string') {
    // If it's already a string, assume it's in ISO format
    return date;
  }
  if (date && typeof date.toJSDate === 'function') {
    // It's a Luxon DateTime object
    return date.toJSDate().toISOString();
  } else if (date && typeof date.toISOString === 'function') {
    // It's a JavaScript Date object
    return date.toISOString();
  } else {
    throw new Error('Invalid date object provided');
  }
};
